export default __webpack_public_path__ + "static/asdc-dd7dd37d772d4dbfe6890ec686b547f7.png";